
import React from 'react';
import MobileStepper from '@mui/material/MobileStepper';

//Styles
import './progressbar.scss'

const ProgressBar = (props) => {
    const { steps, activeStep } = props;

    return (
        <div className='progress-bar-container'>
            <MobileStepper
                className="progress-bar-component"
                variant="progress"
                steps={steps}
                position="static"
                activeStep={activeStep}
            />
        </div>
    )
}

export default ProgressBar;